import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";


import { Label, Input, Button } from 'reactstrap';

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
            camposDelPlan:[],
            selectedRow:'0',
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        label: PropTypes.string,
    }

    getData() {
        const { camposDelPlan } = this.state;

        var i;
        for (i = 0; i < camposDelPlan.length; i++) {
            camposDelPlan[i].ordenamiento = i+1;
        }

        let data = {};
        data.camposDelPlan = camposDelPlan;
        return camposDelPlan
    }

    subirPocision = () => {
        const {camposDelPlan, selectedRow} = this.state;
        if (selectedRow!=null){
            if (selectedRow != 0){
                let pos = parseInt(selectedRow);
                let posAux = parseInt(selectedRow)-1;
                let campoSelect = camposDelPlan[pos];
                let campoSelectAux = camposDelPlan[posAux];

                camposDelPlan[pos] = campoSelectAux;
                camposDelPlan[posAux] = campoSelect;

                this.setState({
                    camposDelPlan: camposDelPlan,
                    selectedRow: posAux,
                });
            }

        }
    }


    bajarPocision = () => {
        const {camposDelPlan, selectedRow} = this.state;
        if (selectedRow!=null){
            if (selectedRow != camposDelPlan.length-1){
                let pos = parseInt(selectedRow);
                let posAux = parseInt(selectedRow)+1;
                let campoSelect = camposDelPlan[pos];
                let campoSelectAux = camposDelPlan[posAux];
                camposDelPlan[pos] = campoSelectAux;
                camposDelPlan[posAux] = campoSelect;

                this.setState({
                    camposDelPlan: camposDelPlan,
                    selectedRow: posAux,
                });
            }
        }
    }

    setData(data) {

        this.setState({
            camposDelPlan: data.rows,
        })
    }

    render() {
        const {camposDelPlan, selectedRow} = this.state;

        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.plan.campos.ordenamiento}
                postUrl={api.proyectos.config.plan.campos.ordenamiento}
                onSubmit={(res) => this.props.onSubmit(res)}
                onPreSubmit={() => this.getData()}
                onGotData={(data) => this.setData(data)}
                //successMessage={"El Campo del Plan de Trabajo ha sido creado con éxito."}
                title={"Ordenar Campos del Plan de Trabajo"}
                buttonTitle={"Ordenar Campo del Plan de Trabajo"}
                buttonIcon={"fa fa-list-ol fa-lg"}

                buttonLabel={this.props.label}
                saveButton={true}
                closeButton={true}
                className={"ui-modal-dialog ui-modal-md"}>
                    <div className="ui-form">
                        <section className="ui-section-block">
                            <p className="ui-section-label">Orden de campos</p>
                            <div className="ui-row-action">
                                <div className="ui-field">
                                    <Label>Campos del plan</Label>
                                    <Input type="select" id="multiSelectInput" value={selectedRow} size={(camposDelPlan.length<12) ? (camposDelPlan.length.toString()) : ("12")} onChange={(e) => {this.setState({selectedRow: e.target.value})}}>
                                {camposDelPlan.map(
                                    (campo, i) =>

                                    <option key={i} value={i}>{(i+1)+"- "+campo.nombre}</option>

                                )}
                                    </Input>
                                </div>

                                <div className="ui-order-actions">
                                    <Button className="ui-icon-btn" style={{ color: 'black' }} onClick={() => this.subirPocision()}>
                                        <i className="fa fa-arrow-up" aria-hidden="true"></i>
                                    </Button>
                                    <Button className="ui-icon-btn" style={{ color: 'black' }} onClick={() => this.bajarPocision()}>
                                        <i className="fa fa-arrow-down" aria-hidden="true"></i>
                                    </Button>
                                </div>
                            </div>
                        </section>
                    </div>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Plan_Campos/CamposOrden.js